import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Button from '../../../../shared/_TBComponents/Button';

const IconButtonWrapper = styled.div`
  svg path {
    fill: ${(props) => {
    if (props.type === 'add' || props.type === 'apa') return '#0DCC8A';
    if (props.type === 'archive') return '#929292';
    if (props.type === 'delete') return '#FF0505';
    return '#77A7FF';
  }} !important;
  }

  button {
    border-color: ${(props) => {
    if (props.type === 'add' || props.type === 'apa') return '#0DCC8A';
    if (props.type === 'archive') return '#929292';
    if (props.type === 'delete') return '#FF0505';
    return '#77A7FF';
  }};
  }

  &:hover button {
    background: ${(props) => {
    if (props.type === 'add' || props.type === 'apa') return '#0DCC8A33';
    if (props.type === 'archive') return '#92929233';
    if (props.type === 'delete') return '#FF050533';
    return '#77A7FF33';
  }};
  }
`;

const IconActionButton = ({ type, onClick, tabIndex }) => {
  const config = {
    add: { name: 'Add User', icon: 'add-user', color: '#0DCC8A' },
    apa: { name: 'APA', icon: 'chart', color: '#0DCC8A' },
    archive: { name: 'Archive', icon: 'download', color: '#929292' },
    edit: { name: 'Edit', icon: 'pencil', color: '#77A7FF' },
    delete: { name: 'Delete', icon: 'delete', color: '#FF0505' },
    restart: { name: 'Restart', icon: 'history', color: '#77A7FF' },
    restore: { name: 'Restore', icon: 'restart', color: '#77A7FF' },
    sort: { name: 'Sort', icon: 'Arrows-Sort', color: '#77A7FF' },
  };

  const { name, icon, color } = config[type] || config.edit;

  return (
    <IconButtonWrapper type={type}>
      <Button
        name={name}
        iconOnly
        icon={icon}
        iconColor={color}
        fontSize='14px'
        customBorderRadius='6px'
        borderColor={color}
        styledWrapperProps={{
          padding: '8px', width: '32px', height: '32px', tabIndex,
        }}
        onClick={onClick}
      />
    </IconButtonWrapper>
  );
};

IconActionButton.propTypes = {
  type: PropTypes.oneOf(['add', 'apa', 'archive', 'edit', 'delete', 'restart', 'restore', 'sort']).isRequired,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
};

IconActionButton.defaultProps = {
  onClick: () => {},
  tabIndex: undefined,
};

export default IconActionButton;
